window.ResetPassword = {
  init() {
    this.validateForm();
  },

  validateForm() {
    $("#new_user").validate({
      onsubmit: true,
      onkeyup: false,
      onclick: false,
      onfocusout: false,
      rules: {
        "user[email]": {
          required: true,
          email: true
        }
      },
      messages: {}
    });
  }
};
